import "./style.css";
import { Suspense, useState, useRef } from "react";
import { Canvas } from "@react-three/fiber";
import { KeyboardControls, Html } from "@react-three/drei";
import { Physics } from "@react-three/rapier";
import Experience from "./Experience.jsx";
import LockedPointerControls from "./LockedPointerControls.jsx";
import useGame from './stores/useGame.js'
import AudioController from "./controller/AudioController";
import LoadingScreen from './component/LoadingScreen.jsx'
import DoorMessage from './component/DoorMessage.jsx'
import MadnessTrigger from './component/MadnessTrigger.jsx'
import SucceedMessage from './component/SucceedMessage.jsx'
import Gameover from './component/Gameover.jsx'

// Start of the code
// THREE.ColorManagement.enabled = false

const created = (state) => {
  // state.gl.outputColorSpace = THREE.LinearSRGBColorSpace
};

    // Function to check if the user is on a mobile device
    function isMobileDevice() {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    };

  const isMobile = isMobileDevice();



export default function App() {

  if (isMobile) {
    return (
      <div className={"mobile-disclaimer"}>
        Unfortunately, the Shepard Tone is a desktop-only experience (for now). Please visit from a desktop device. Thank you.
      </div>
    );
  }
 
    // State
    const [start, setStart] = useState(false);
    const showDoorMessage = useGame((state) => {return state.showEscape})
    const showCountdown = useGame((state)=> {return state.showCountdown})
    const portalEntered = useGame((state)=>{return state.portalEntered})
    const countdownEnded = useGame((state)=>{return state.countdownEnded})

    // const setWelcome = useGame((state)=>{return state.setWelcome})
    // Reload 
    function restart() {
        window.location.reload(true);
    }

    return ( <>
        <AudioController/>
        <KeyboardControls
        map={[
          { name: "forward", keys: ["ArrowUp", "KeyW",] },
          { name: "back", keys: ["ArrowDown", "KeyS"] },
          { name: "left", keys: ["ArrowLeft", "KeyA"] },
          { name: "right", keys: ["ArrowRight", "KeyD"] },
          { name: "jump", keys: ["Space"] },
        ]}>

        {(countdownEnded || portalEntered) ? null : <Canvas

              background={'#880808'}
              camera={{
                fov: 50,
                near: 0.1,
                far: 2000,
                position: [-10, 0, 0],
              }}
              onCreated={created}
            >
              <color attach="background" args={['#880808']} />
              <fog attach="fog" args={['#880808', 30, 20000]} />
        
            <LockedPointerControls/>

            {/* <OrbitControls makeDefault/> */}        
            <Suspense fallback={null}>            
              <Physics debug={ false } gravity={[0, -59.81, 0]}>
                <Experience updateShowEscape={()=>{setEscape()}} />
              </Physics>
            </Suspense>

        </Canvas>}

        <LoadingScreen started={start} onStarted={
          ()=>{setStart(true)
              // setWelcome(true)
          }
          }/>

        {/* Door Message */}
        {showDoorMessage && <DoorMessage/>}

        {/* Madness Message */}
        {showCountdown && <MadnessTrigger/>}

        {/* Success */}
        {portalEntered && <SucceedMessage/>}

        {/* Restart */}
        {countdownEnded && <Gameover/>}

      </KeyboardControls>
      </>
    )
 
}


  
